import { useState } from "react";
import { Accessibility, ZoomIn, ZoomOut, Contrast, RotateCcw, X } from "lucide-react";
import { Link } from "react-router-dom";

export default function AccessibilityWidget() {
  const [open, setOpen] = useState(false);
  const [fontSize, setFontSize] = useState(100);
  const [highContrast, setHighContrast] = useState(false);

  const increaseFontSize = () => {
    const next = Math.min(fontSize + 10, 150);
    setFontSize(next);
    document.documentElement.style.fontSize = `${next}%`;
  };

  const decreaseFontSize = () => {
    const next = Math.max(fontSize - 10, 80);
    setFontSize(next);
    document.documentElement.style.fontSize = `${next}%`;
  };

  const toggleContrast = () => {
    setHighContrast(!highContrast);
    document.documentElement.classList.toggle("high-contrast");
  };

  const resetAll = () => {
    setFontSize(100);
    setHighContrast(false);
    document.documentElement.style.fontSize = "100%";
    document.documentElement.classList.remove("high-contrast");
  };

  return (
    <>
      {/* Floating button */}
      <button
        onClick={() => setOpen(!open)}
        aria-label="תפריט נגישות"
        className="fixed bottom-6 left-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg hover:bg-primary/90 transition-all duration-200 hover:scale-105"
      >
        <Accessibility className="h-6 w-6" />
      </button>

      {/* Panel */}
      {open && (
        <div
          className="fixed bottom-20 left-6 z-50 w-64 rounded-xl border border-border bg-background p-4 shadow-2xl"
          dir="rtl"
        >
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-sm font-bold text-foreground">הגדרות נגישות</h3>
            <button onClick={() => setOpen(false)} aria-label="סגור תפריט נגישות" className="text-muted-foreground hover:text-foreground">
              <X className="h-4 w-4" />
            </button>
          </div>

          <div className="space-y-3">
            {/* Font size */}
            <div className="flex items-center justify-between">
              <span className="text-sm text-foreground">גודל טקסט</span>
              <div className="flex gap-2">
                <button onClick={decreaseFontSize} aria-label="הקטן טקסט" className="rounded-lg border border-border p-1.5 hover:bg-muted transition-colors">
                  <ZoomOut className="h-4 w-4" />
                </button>
                <button onClick={increaseFontSize} aria-label="הגדל טקסט" className="rounded-lg border border-border p-1.5 hover:bg-muted transition-colors">
                  <ZoomIn className="h-4 w-4" />
                </button>
              </div>
            </div>

            {/* Contrast */}
            <button
              onClick={toggleContrast}
              className={`flex w-full items-center justify-between rounded-lg border p-2 text-sm transition-colors ${
                highContrast ? "border-primary bg-primary/10 text-primary" : "border-border hover:bg-muted text-foreground"
              }`}
            >
              <span>ניגודיות גבוהה</span>
              <Contrast className="h-4 w-4" />
            </button>

            {/* Reset */}
            <button
              onClick={resetAll}
              className="flex w-full items-center justify-between rounded-lg border border-border p-2 text-sm text-foreground hover:bg-muted transition-colors"
            >
              <span>איפוס הגדרות</span>
              <RotateCcw className="h-4 w-4" />
            </button>

            {/* Link to full statement */}
            <Link
              to="/accessibility"
              onClick={() => setOpen(false)}
              className="block text-center text-xs text-primary hover:underline pt-1"
            >
              הצהרת נגישות מלאה
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
